module.exports = __webpack_public_path__ + "img/组 4.76f130f9.webp";